import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import * as PRTNR from "./prtnr";
import { donatePayoutRequest } from "./redux/slices/payoutRequestsThunk";

const ModalContainer = styled.div`
  width: 516px;
  border-radius: 12px;
  padding: 24px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--Padding-Normal, 16px);
  align-self: stretch;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Title = styled.h2`
  color: var(--Color-Text-Text, #212543);
  text-align: left;
  width: 100%;

  /* H6 */
  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const Highlight = styled.span`
  color: var(--Color-Brand-Secoundary, #6162c5);

  /* H6 */
  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const Champagne = styled.img`
  width: 174px;
  height: 174px;
`;


const CharityItem = styled.label`
  display: flex;
  height: 48px;
  padding: var(--Padding-Normal, 16px) 16px 16px 16px;
  align-items: center;
  gap: var(--Padding-Small, 8px);
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid var(--stroke-soft-200, #e1e4ea);
  background: var(--bg-white-0, #fff);
  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
  cursor: pointer;
  &:hover {
    background: #f9f9f9;
  }
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }

  input {
    accent-color: #6162c5;
  }
`;

const CharityInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--Color-Brand-Primary, #212543);

  /* P4 */
  font-family: Montserrat;
  font-size: var(--Fonts-P4, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 22.4px */
`;



const Donate = styled.div`
  display: flex;
  width: 100%;
  padding: var(--Padding-Normal, 16px) var(--Padding-Big, 24px) 16px
    var(--Padding-Big, 24px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Padding-Small, 8px);
  border-radius: var(--radius-16, 16px);
  border: 1px solid var(--stroke-soft-200, #e1e4ea);
  background: var(--bg-white-0, #fff);

  /* regular-shadow/x-small */
  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
  p {
    color: var(--Color-Brand-Secoundary, #6162c5);

    /* P3 */
    font-family: Montserrat;
    font-size: var(--Fonts-P3, 16px);
    font-style: normal;
    font-weight: 700;
    line-height: 160%; /* 25.6px */
    letter-spacing: -0.16px;
  }
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: 12px;
`;

const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const SuccessMessage = styled.div`
  color: #166534;
  background-color: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  margin: 8px 0;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 500;
  text-align: center;
`;
const ErrorMessage = styled.div`
  color: #dc3545;
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  margin: 8px 0;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 500;
  text-align: center;
`;

const DonatetoCharityModal = ({
  onClose,
  selectedRequest,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleDonate = async () => {
    if (!selectedRequest?._id) return;

    setIsLoading(true);
    setError("");
    setSuccess("");

    try {
      await dispatch(donatePayoutRequest(selectedRequest._id)).unwrap();
      setSuccess("✅ Donation status updated successfully!");
      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (err) {
      console.error("❌ Donate error:", err);
      const errorMessage =
        err?.message ||
        err?.data?.message ||
        "Failed to update donation status. Please try again.";
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <ModalContainer>
      <Champagne src="https://d3nakrlcog1u3z.cloudfront.net/1751293449884-image (4).png" />
      <Title>Payout Request #{selectedRequest.requestId}</Title>
      <Title>
        Amount: <Highlight>{selectedRequest.amount}</Highlight>
      </Title>
      <Donate>
        <p>Donate to Charity </p>
        <CharityItem key={selectedRequest.payout_request.charity._id}>
          <CharityInfo>
            <img
              src={selectedRequest.payout_request.charity.logo}
              alt={selectedRequest.payout_request.charity.name}
            />
            {selectedRequest.payout_request.charity.name || "Test"}
          </CharityInfo>
        </CharityItem>
      </Donate>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {success && <SuccessMessage>{success}</SuccessMessage>}
      {selectedRequest.donation_status !== "Donated" && (
        <Frame58>
          <Frame59>
            <PRTNR.Button
              size="small"
              onClick={onClose}
              variant="gray"
              disabled={isLoading}
              style={{ flex: 1 }}
            >
              Cancel
            </PRTNR.Button>

            <PRTNR.Button
              size="small"
              onClick={handleDonate}
              disabled={
                isLoading || selectedRequest.payout_request.status === "donated"
              }
              style={{ flex: 1 }}
            >
              <div
                style={{ display: "flex", flexDirection: "row", width: "100%" }}
              >
                <>{isLoading && <LoadingSpinner />}</>
                <>{isLoading ? "loading...." : "Donate"}</>
              </div>
            </PRTNR.Button>
          </Frame59>
        </Frame58>
      )}
    </ModalContainer>
  );
};

export default DonatetoCharityModal;

